import { useAuth } from '@slr/shared-library';

const PLATFORM_ADMIN_REALM_ROLE = 'slr-admin';

export const useIsPlatformAdmin = (): boolean => {
  const { tokenParsed } = useAuth();
  const realmRoles = tokenParsed?.realm_access?.roles;
  return Array.isArray(realmRoles) && realmRoles.includes(PLATFORM_ADMIN_REALM_ROLE);
};
